import { FC, SyntheticEvent, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import SimulationsTable from './SimulationsTable'
import SimulationsEditModal from './SimulationsEditModal'
import SimulationResultModal from './SimulationResultModal'

const SimulationsList: FC = () => {
  const [itemIdForUpdate, setItemIdForUpdate] = useState<string>('')
  const [refreshFunction, setRefreshFunction] = useState<any>(() => {})
  const [showResultModal, setShowResultModal] = useState<boolean>(false)
  const [selectedSimulation, setSelectedSimulation] = useState<any>(null)

  const handleViewResult = (id: any) => {
    axios.get('/simulations/single/' + id).then((response) => {
      setSelectedSimulation(response.data.data)
      setShowResultModal(true)
    })
  }

  return (
    <>
      <SimulationsTable
        enablePolling={true}
        pollingInterval={5000}
        onEdit={(id: any, refresh: Function) => {
          setRefreshFunction(() => refresh)
          setItemIdForUpdate(id)
        }}
        onViewResult={handleViewResult}
        onDelete={(id: any, refresh: Function) => {
          axios.get('/simulations/save/' + id).then((response) => {
            let csrfData = response.data.data
            Swal.fire({
              title: 'Warning',
              html: 'Are you sure you want to delete this simulation?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Delete',
              cancelButtonText: 'Cancel',
              customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-primary',
              },
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .delete('/simulations/save/' + id, {
                    data: csrfData,
                  })
                  .then(() => {
                    refresh()
                  })
              }
            })
          })
        }}
        onAdd={(_event: SyntheticEvent, refresh: Function) => {
          setItemIdForUpdate('add')
          setRefreshFunction(() => refresh)
        }}
      />
      {itemIdForUpdate !== '' ? (
        <SimulationsEditModal
          show={itemIdForUpdate !== ''}
          itemIdForUpdate={itemIdForUpdate}
          onHide={() => {
            setItemIdForUpdate('')
          }}
          refreshFunction={(itemId: any) => {
            if (itemId !== undefined) {
              setItemIdForUpdate(itemId)
            }
            refreshFunction()
          }}
        />
      ) : (
        <></>
      )}
      {showResultModal && (
        <SimulationResultModal
          show={showResultModal}
          onHide={() => setShowResultModal(false)}
          simulation={selectedSimulation}
        />
      )}
    </>
  )
}

export default SimulationsList
